module.exports = __webpack_public_path__ + "static/img/img_h.a8332d02.png";